export enum FolioTypeEnum 
{
    Property,
    Bracelets,
    OtherServices
}
